import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Login, CambiarPassword } from '../../interfaces/beans.interface';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from '../../services/usuario.service';
import { Title } from '@angular/platform-browser';
import { APIService } from 'src/app/services/api.service';
import { initNgModule } from '@angular/core/src/view/ng_module';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})

export class LoginComponent implements AfterViewInit {
  APIVersion = '1.0.0';
  isChecked = false;
  loginform = true;
  recoverform = false;
  usuario: Login = {
    username: null,
    password: null,
    version: null
  };
  contrasenia: CambiarPassword = {
    password1: null,
    password2: null
  };
  // Policy Password
  longitud: boolean = false;
  mayuscula: boolean = false;
  numero: boolean = false;
  caracterEspecial: boolean = false;
  minuscula: boolean = false;
  // Ventana Modal
  modal: any;
  userpass: string;

  constructor(private apiService: APIService, private titleService: Title, private router: Router, private http: HttpClient, private loginService: LoginService, private usuarioService: UsuarioService, private toastr: ToastrService, private spinner: NgxSpinnerService, private modalService: NgbModal) {
    this.titleService.setTitle('net.Home');
    if (localStorage.getItem('noCloseSesion') != null) {
      this.recordar();
    } else {
      localStorage.clear();
    }
  }

  ngAfterViewInit() {
    this.apiService.get().subscribe(        
      message => {
        if (message['httpStatus'] === 200) {
          this.APIVersion = message['version'];          
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para iniciar sesión');
        }
      },
    );
  }

  login(content: any) {
    if (this.usuario.username.length > 4 && this.usuario.password.length > 3) {
      this.spinner.show();
      this.loginService.getLogin(this.usuario).subscribe(        
        message => {
          if (message['httpStatus'] === 200) {
            let usuario = message['usuario'];
            localStorage.setItem('token', message['token']);
            localStorage.setItem('idUsuario', usuario.username);
            localStorage.setItem('login', JSON.stringify(this.usuario));
            if(this.usuario.username === 'soporte'){
              localStorage.setItem('superUsuario', 'true');
            }
            if (!usuario.cambiarClave) {
              this.showModal(content);
            } else {
              console.log('Entrando pedidos...');
              this.router.navigate(['dashboard/pedidos']);
            }
          } else if (message['httpStatus'] === 400) {
            this.showMessage('error', message['message'], message['messageDetail']);
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para iniciar sesión');
          }
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    }else{
      this.showMessage('error', 'Error de usuario', 'El ID del usuario debe ser mayor a 4 caracteres');
    }
  }

  cambiarPassword(cambiarPasswordForm: NgForm) {
    if (cambiarPasswordForm['valid']) {
      if (this.longitud && this.mayuscula && this.numero && this.caracterEspecial && this.minuscula) {
        if (this.contrasenia.password1 === this.contrasenia.password2) {
          this.spinner.show();
          this.usuarioService.updatePassword(this.contrasenia).subscribe(
            message => {
              if (message['httpStatus'] === 200) {
                this.showMessage('success', 'Cambio de password', 'Password cambiados exitosamente');
                this.closeModal();
                this.router.navigate(['dashboard/pedidos']);
              } else if (message['httpStatus'] === 400) {
                this.showMessage('error', message['message'], message['messageDetail']);
              }
            },
            error => {
              if (error.status === 0) {
                this.showMessage('error', 'Error de conexión', 'No se pudo actulizar el password del usuario');
              }
              this.spinner.hide();
            },
            () => {
              this.spinner.hide();
            }
          );
        } else {
          this.showMessage('error', 'Error de cambio de password', 'Los passwords no coinciden');
        }
      }
    }
  }

  verificarPassword() {
    if (this.contrasenia.password1.length >= 8) {
      this.longitud = true;
    } else {
      this.longitud = false;
    }
    let regNumber = new RegExp('^.*[0-9].*');
    if (regNumber.test(this.contrasenia.password1)) {
      this.numero = true;
    } else {
      this.numero = false;
    }
    let regMayuscula = new RegExp('^.*[A-Z].*');
    if (regMayuscula.test(this.contrasenia.password1)) {
      this.mayuscula = true;
    } else {
      this.mayuscula = false;
    }
    let regMinuscula = new RegExp('^.*[a-z].*');
    if (regMinuscula.test(this.contrasenia.password1)) {
      this.minuscula = true;
    } else {
      this.minuscula = false;
    }
    let regCaracterEspecial = new RegExp('(?=.*[!#$%@/()=¡¿*+:;,.-])');
    if (regCaracterEspecial.test(this.contrasenia.password1)) {
      this.caracterEspecial = true;
    } else {
      this.caracterEspecial = false;
    }
  }

  recordar() {
    this.usuario = JSON.parse(localStorage.getItem('login'));
    this.loginService.getLogin(this.usuario).subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          localStorage.setItem('token', message['token']);
          localStorage.setItem('idUsuario', message['usuario']);
          localStorage.setItem('usuario', JSON.stringify(this.usuario));
          this.router.navigate(['dashboard/pedidos']);
        } else if (message['httpStatus'] === 400) {
          this.showMessage('error', message['message'], message['messageDetail']);
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para iniciar sesión');
        }
        this.spinner.hide();
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  sendPass(){
    if(this.userpass.length > 0){
      this.loginService.recup(this.userpass).subscribe(
        message => {
          if (message['httpStatus'] === 200) {
            let usuario = message['usuario']; 
            if(message['messageDetail'] == 'OK'){
              this.showMessage('success', '', 'Realizado');
            }else{
              this.showMessage('warning', '', 'Procesado');
            }
            this.router.navigate(['login']);
            
          } else if (message['httpStatus'] === 400) {
            this.showMessage('error', message['message'], message['messageDetail']);
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para iniciar sesión');
          }
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    }
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
  }

  checked() {
    if (this.isChecked === false) {
      this.isChecked = true;
      localStorage.setItem('noCloseSesion', 'SI');

    } else if (this.isChecked === true) {
      this.isChecked = false;
      localStorage.removeItem('noCloseSesion');
    }
  }

  showModal(content: any) {
    this.modal = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

  closeModal() {
    this.modal.dismiss();
  }
}
